import { Component, ElementRef, inject, Injector, NgZone, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {Subscription} from 'rxjs';
import { AppManagerService } from '../services/app.manager.service';
import { BasePageComponent } from './base-page.component';
import { ComponentRefProvider, ComponentType } from '../types/types';
import {EventManagerService} from "@wms/app";
import { runtimeEventManager } from '@wm/core';
import {forEach, isString} from "lodash-es";
import { MarkupManagerService } from "@wms/core";
import {NotificationService, PrefabCacheService} from "@wms/services";
import { clearWidgetRegistry } from '@wm/components-base';
@Component({
    selector: 'app-page-outlet',
    template: '<div></div>',
    standalone: true
})
export class PageWrapperComponent implements OnInit, OnDestroy {

    subscription: Subscription = new Subscription();
    instance: any;

    private injector: Injector;
    private route: ActivatedRoute;
    private vcRef: ViewContainerRef;
    private appManager: AppManagerService;
    private ngZone: NgZone;
    private elRef: ElementRef;
    private componentRefProvider: ComponentRefProvider;
    private router: Router;
    private eventManager: EventManagerService;
    private prefabCacheService: PrefabCacheService;
    private notificationService: NotificationService;

    constructor(private markupManager: MarkupManagerService) {
      this.injector = inject(Injector);
      this.route = inject(ActivatedRoute);
      this.vcRef = inject(ViewContainerRef);
      this.appManager = inject(AppManagerService);
      this.ngZone = inject(NgZone);
      this.elRef = inject(ElementRef);
      this.componentRefProvider = inject(ComponentRefProvider);
      this.router = inject(Router);
      this.eventManager = inject(EventManagerService);
      this.prefabCacheService = inject(PrefabCacheService);
      this.notificationService = inject(NotificationService);

      runtimeEventManager.setService('componentRefProvider', this.componentRefProvider);
    }

    getTargetNode() {
        return this.elRef.nativeElement;
    }

    resetViewContainer() {
        this.vcRef.clear();
        const $target = this.getTargetNode();
        $target.innerHTML = '';
    }

    renderPage(pageName: string) {
        const $target = this.getTargetNode();
        this.eventManager.emitSelectPage(pageName);
        this.appManager.loadAppVariables()
            .then(() => this.componentRefProvider.getComponentFactoryRef(pageName, ComponentType.PAGE).then((response: any) => {
                // const pageComponentFactoryRef = await this.componentRefProvider.getComponentFactoryRef(pageName, ComponentType.PAGE);
              const pageComponentFactoryRef = response;
                if (pageComponentFactoryRef) {
                  // const componentRef = this.vcRef.createComponent(pageComponentFactoryRef, 0, this.injector);
                  const componentRef = pageComponentFactoryRef
                  this.instance = componentRef.instance;
                  $target.innerHTML = '';
                  $target.appendChild(componentRef.location.nativeElement);
                  this.eventManager.emitPageRenderedEvt(pageName);
                } else {
                  BasePageComponent.clear();
                }
                if (this.vcRef.length > 1) {
                  this.vcRef.remove(1);
                }
              }));
    }

    renderPrefabPreviewPage() {
        this.router.navigate(['prefab-preview']);
    }

    loadPage(pageName: string) {
      this.markupManager.resetIdMap();
        this.ngZone.run(() => {
            if (pageName) {
              // Before rendering page, getting all the prefabData in the page.
              this.prefabCacheService.loadPagePrefabData(pageName).then(() => {
                this.renderPage(pageName);
              }, (err) => {
                if (err) {
                  const msg = "Error while loading page";
                  console.log(msg, err);
                  this.notificationService.show("error", 'Error', msg + ' ' + pageName +', check browser console for error details',);
                }
              });
            }
        });
    }

    ngOnInit() {
      // this.subscription.add(this.eventManager.renderCanvasContentObservable().subscribe((obj: {pageName: string, content: any, isUpdated: boolean}) => {
      //   // TODO: page caching
      //   // if (obj.content && obj.isUpdated) {
      //   //   this.componentRefProvider.updateFragmentResources(obj.content, obj.pageName, ComponentType.PAGE);
      //   // }
      //   this.eventManager.emitBeforePageRender(obj.pageName);
      //   if (this.appRef.isPrefabType) {
      //     // there is only one route
      //     this.renderPrefabPreviewPage();
      //   } else {
      //     $(this.getTargetNode()).find('>div').first().remove();
      //     this.subscription.add(this.route.params.subscribe(({pageName}: any) => {
      //       this.loadPage(pageName);
      //     }));
      //   }
      // }));
      this.subscription.add(this.eventManager.reRenderCanvasContentObservable().subscribe((data: {pageName: string, isMarkupUpdated: boolean}) => {
        if (data.isMarkupUpdated) {
          this.loadPage(data.pageName);
        }
      }));
      this.subscription.add(this.route.params.subscribe(({pageName}: any) => {
        this.instance && this.clearWidgetRegistry();
        this.loadPage(pageName);
      }));
    }

    clearWidgetRegistry() {
      clearWidgetRegistry();
      forEach(this.instance.Widgets, (w: any) => {
        w?.destroy?.complete()
      });
    }

    ngOnDestroy() {
        this.vcRef.clear();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
      // TODO: like if there are specific to widget , then destroy them on pagewrapper (which will be triggered for every page navigation )
      // runtimeEventManager.off();
    }

    ngOnAttach() {
        this.getTargetNode().appendChild(this.instance.$page[0]);
        this.instance.ngOnAttach();
    }

    ngOnDetach() {
        this.instance.ngOnDetach();
    }
}
